import { Divider, Grid } from "@material-ui/core";
import React from "react";
import {
  formatDate,
  formatDocument,
} from "../../../../../../../../utils/formatters";
import DataCell from "../../cells/data";

const CompanyPartnerData = ({ data }) =>
  data && data.length > 0 ? (
    <>
      <Divider className="mt-20 mb-20 w-100" />

      <Grid spacing={3} container>
        <Grid xs={12} className="qd-data-cell-label" item>
          {data.length == 1
            ? "Participação em empresa"
            : "Participações em empresas"}
        </Grid>

        {data.map(({ dataEntrada, empresa: { cnpj, razaoSocial } }) => (
          <React.Fragment key={`${cnpj}-${dataEntrada}`}>
            <DataCell
              xs={12}
              md={6}
              value={
                <>
                  <div>{razaoSocial}</div>
                  <div>{formatDocument(cnpj)}</div>
                </>
              }
            />

            <DataCell
              xs={12}
              md={6}
              value={`Entrada em ${
                dataEntrada ? formatDate(dataEntrada) : "indisponível"
              }`}
            />
          </React.Fragment>
        ))}
      </Grid>
    </>
  ) : null;

export default CompanyPartnerData;
